import { Translations } from './en';

export const sv: Translations = {
    welcome: 'Välkommen',
    welcomeMessage: 'Logga in på plandag för att se ditt schema.',
    login: 'Logga in',
    register: 'Registrera',
    forgotPassword: 'Glömt lösenord',
    resetPassword: 'Återställ lösenord',
    email: 'E-post',
    password: 'Lösenord',
    confirmPassword: 'Bekräfta lösenord',
    rememberMe: 'Kom ihåg mig',
    continue: 'Fortsätt',
    selectOrganization: 'Välj organisation',
    organizationEmail: 'E-postadressen <span class="font-semibold text-[#00165A] bg-slate-100 px-1.5 py-0.5 rounded">{{email}}</span> är kopplad till flera organisationer.',
    organizationEmailMessage: 'Välj den arbetsyta du vill komma åt.',
    organization: 'Organisation',
    chooseOrganization: 'Välj en organisation',
    backToLogin: 'Tillbaka till inloggning',
    theEmail: 'E-postadressen',
    isAssociatedWithMultipleOrganizations: 'är kopplad till flera organisationer.',
    theSimplestWayToManage: 'Det enklaste sättet att hantera',
    yourWorkforce: 'din personal',
    loginRightPanelMessage: 'Ge ditt team ett verktyg byggt för hastighet, enkelhet och kontroll. Från budgetuppföljning till automatisering av arbetsflöden fungerar allt tillsammans så att du kan fokusera på tillväxt, inte administration.',
    personalDetails: 'Personuppgifter',
    businessDetails: 'Företagsuppgifter',
    createYourAccount: 'Skapa ditt konto',
    name: 'Namn',
    willBeUsedAsUsernameForLogin: '(används som användarnamn vid inloggning)',
    enterYourName: 'Ange ditt namn',
    enterYourEmail: 'Ange din e-post',
    select: '--Välj--',
    phoneNumber: 'Telefonnummer',
    enterYourMobileNumber: 'Ange ditt mobilnummer',
    country: 'Land',
    atLeastOneLowercase: 'Minst en liten bokstav',
    atLeastOneUppercase: 'Minst en stor bokstav',
    atLeastOneNumeric: 'Minst en siffra',
    minimum8Characters: 'Minst 8 tecken',
    agreeAndContinue: 'Godkänn och fortsätt',
    personalDetailsMessage: 'Det här språket blir standard för systemaviseringar och nya användare. Du kan alltid ändra det i användarinställningarna senare.',
    agreeAndContinueMessage: 'Genom att klicka på godkänn och fortsätt bekräftar du att du har läst och godkänt vårt personuppgiftsbiträdesavtal, vår integritetspolicy, provperiodsvillkoren och de allmänna villkoren samt samtycker till att ta emot säljkommunikation via telefon, e-post eller Wiser-appen under din 30-dagars provperiod. Du kan avregistrera dig när som helst.',
    tellUsAboutYourBusiness: 'Berätta om ditt företag',
    withABusinessDetails: 'Med några företagsuppgifter anpassar vi Wiser för ditt företag och din domän',
    businessName: 'Företagsnamn',
    enterYourBusinessName: 'Ange ditt företagsnamn',
    businessLocation: 'Företagets plats',
    businessType: 'Företagstyp',
    language: 'Språk',
    timezone: 'Tidszon',
    howManyEmployeesDoYouHave: 'Hur många anställda har du?',
    previous: 'Föregående',
    createAccount: 'Skapa konto',
    startYour30DaysTrial: 'Starta din 30-dagars provperiod',
    noCreditCardRequired: 'Inget kreditkort krävs!',
    exploreWiserFeaturesAtNoCost: 'Utforska Wiser-funktioner utan kostnad!',
    forgotYourPassword: 'Glömt ditt lösenord?',
    enterYourEmailAddressAndWeWillSendYou: 'Ange din e-postadress så skickar vi',
    instructionsToResetYourPassword: 'instruktioner för att återställa ditt lösenord.',
    youHaveReachedTheEmailRequestLimit: 'Du har nått gränsen för e-postförfrågningar. Kontrollera din inkorg eller försök igen om 15 minuter.',
    checkYourEmail: 'Kontrollera din e-post',
    pleaseCheckTheEmailAddress: 'Kontrollera e-postadressen',
    forInstructionsToResetYourPassword: 'för instruktioner för att återställa ditt lösenord.',
    aNewEmailHasBeenSentToYourInbox: 'Ett nytt e-postmeddelande har skickats till din inkorg.',
    resendEmail: 'Skicka e-post igen',
    edit: 'Redigera',
    thisFieldIsRequired: 'Det här fältet är obligatoriskt',
    invalidEmailAddress: 'Ogiltig e-postadress',
    pleaseEnterAValidEmailAddress: 'Ange en giltig e-postadress',
    invalidPassword: 'Ogiltigt lösenord',
    minimumLengthIs: 'Minsta längd är {{length}}',
    maximumLengthIs: 'Största längd är {{length}}',
    passwordsDoNotMatch: 'Lösenorden matchar inte',
    invalidField: 'Ogiltigt fält',
};